import {
  CampaignTypeEnum,
  ChannelEnum,
  ModeEnum,
  RFMPeriod,
  StatusEnum,
  TypeEnum,
} from "../constants/enums";
import { MessageTemplateData } from "./messageTemplates";
import { Segment } from "./segment";

export type Type = "One-Time" | "Recurring - Weekly" | "Recurring - Monthly";
export type Status =
  | "Draft"
  | "Active"
  | "Scheduled"
  | "Paused"
  | "Completed"
  | "Cancelled";

export type CampaignRegisteredChannel = {
  Id?: number;
  Email: string;
  ContactIdd: string;
  ContactNumber: string;
  ClientId: string;
  Channel: ChannelEnum;
  Status: boolean;
  BrandId: string;
};

export const createCampaignRegisteredChannel = (input: {
  email: string;
  clientId: string;
  brandId: string;
  channel: ChannelEnum;
  contactIdd: string;
  contactNumber: string;
}): CampaignRegisteredChannel => ({
  Email: input.email,
  ContactIdd: input.contactIdd,
  ContactNumber: input.contactNumber,

  ClientId: input.clientId,
  Channel: input.channel,
  Status: true,
  BrandId: input.brandId,
});

export type Campaign = {
  Id?: number;
  key: string;
  Name: string;
  Channel: ChannelEnum;
  ScheduleType: TypeEnum;
  Status: StatusEnum;
  CampaignStart?: string;
  CampaignEnd?: string;
  nextSchedule?: string;
  Segments: Segment[];
  criteriaProfile: string;
  CreatedDate: Date;
  CampaignRunLog?: CampaignRunLog[];
  EstimatedTotalMembers?: number;
  Mode?: ModeEnum;
  Budget?: number;
};

export type CampaignDetails = {
  Id?: number;
  Name: string;
  Type?: CampaignTypeEnum;
  RFMPeriod?: RFMPeriod;
  FromAge?: number;
  ToAge?: number;
  Messages: {
    Id?: number;
    Link?: string;
    Content?: string;
    CampaignTemplates?: MessageTemplateData | null;
  }[];
  Segments: {
    Id?: number;
    SegmentId: number;
    SegmentName?: string;
  }[];
  PostalDistricts: {
    Id?: number;

    DistrictId: number;
    PostalSectors?: string[];
  }[];
  RFMProfile?: number;
  RFMProfileName?: string;

  BrandId?: string;
  Status?: StatusEnum;
  VoucherId?: number;
  CampaignStart: string;
  CampaignEnd: string;
  Budget?: number;
  EstimatedTotalMembers: number;
  ScheduleType: TypeEnum;
  ImageUrl?: string;
  Channel?: ChannelEnum;
  CreatedDate?: Date;
  SKU?: string;
  CampaignRunLog?: CampaignRunLog[];
  PurchaseBrand?: string | null;
  PurchaseBrandList?: string[] | null;
  TemplateType?: number;
  InactiveDays?: number;
  Mode?: ModeEnum;
  IsBilled?: number;
  ReferenceCode?: string;
};

export type CampaignRunLog = {
  Id: number;
  SuccessCount: number;
  FailCount: number;
  TotalMembers: number;
  MemberLogs: any[];
  EndDate: Date;
  CreatedDate?: Date;
  IsBilled?: boolean;
};

export type CampaignMemberLog = {
  Id: number;
  Name: string;
  ContactIdd: string;
  ContactNumber: string;
  SendDate: Date;
  Status: boolean;
  notes?: string;
};

export type CompletedCampaign = {
  key: string;
  name: string;
  channel: ChannelEnum;
  type: Type;
  completedOn?: string;
  segments: string[];
  criteriaProfile: string;
  ctr: number;
  roi: number;
  revenue: number;
};

export type CompletedCampaignViewModel = {
  CampaignName: string;
  CampaignId: number;
  CampaignRunLogId: number;

  RevenueRewards: number;
  TotalOrderRewards: number;

  RevenueCampaign: number;
  TotalOrderCampaign: number;

  ROI: number;
  TotalFee: number;
  CTR: number;

  Clicks: number;
  MessageDelivered: number;

  Channel: string;
  CampaignStart: string;
  CampaignEnd: string;
  ScheduleType: string;

  RFMProfile: string;
  Segments: { Id: string; Name: string; SegmentId: number }[]; // adjust if IDs are numbers
};

export type EstimatedTotalMembersRequest = {
  BrandId: string;
  RFMProfile: number;
  RFMPeriod: number;
  SegmentIds: number[];
  IncludeListMember: boolean;
  FromAge?: number;
  ToAge?: number;
  PostCode?: string[];
  PurchaseBrand?: string[] | null;
  CampaignType?: number;
  TemplateType?: number;
  InactiveDays?: number;
};

export type CampaignInfo = {
  Email: string;
  MemberPortalUrl: string;
  BrandName: string;
  Currency?: string;
};
